var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 76,
    viewBox: "0 0 301 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.109 75.9998H39.2926C19.3912 75.9998 4.82228 55.3074 0 37.9999C4.82228 20.6839 19.3912 0 39.2926 0H261.117C281.019 0 295.588 20.6924 300.41 37.9999C295.588 55.3159 281.019 75.9998 261.117 75.9998H261.109ZM265.931 57.8843C271.961 57.391 276.766 53.8955 280.389 49.2434C281.971 47.2107 283.324 44.9654 284.429 42.6436C285.118 41.1977 285.799 39.5648 286.224 37.9999C285.799 36.4265 285.118 34.802 284.429 33.3562C283.324 31.0344 281.971 28.7891 280.389 26.7564C276.766 22.1042 271.961 18.6087 265.931 18.1154L264.392 17.9879V16.44C264.392 10.1378 259.28 5.02639 252.978 5.02639H47.4233C41.1212 5.02639 36.0097 10.1378 36.0097 16.44V17.9879L34.4704 18.1154C28.4404 18.6087 23.6351 22.1042 20.012 26.7564C18.4301 28.7891 17.0778 31.0344 15.9722 33.3562C15.2833 34.802 14.6114 36.435 14.1777 37.9999C14.6029 39.5733 15.2833 41.1977 15.9722 42.6436C17.0778 44.9654 18.4301 47.2107 20.012 49.2434C23.6351 53.8955 28.4404 57.391 34.4704 57.8843L36.0097 58.0119V59.5598C36.0097 65.8619 41.1212 70.9734 47.4233 70.9734H252.97C259.272 70.9734 264.383 65.8619 264.383 59.5598V58.0119L265.923 57.8843H265.931Z",
    fill: "url(#paint0_linear_318_3208)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48701 37.9999C8.13068 22.3764 21.3898 3.35093 39.2926 3.35093H261.117C279.012 3.35093 292.271 22.3764 296.914 37.9999H300.402C295.579 20.6924 281.01 0 261.109 0H39.2926C19.3912 0 4.82228 20.6839 0 37.9999H3.48701Z",
    fill: "url(#paint1_radial_318_3208)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48701 38C8.13068 53.6235 21.3898 72.649 39.2841 72.649H261.109C279.003 72.649 292.262 53.6235 296.906 38H300.393C295.571 55.3075 281.002 75.9999 261.1 75.9999H39.2926C19.3997 75.9999 4.82228 55.316 0 38H3.48701Z",
    fill: "url(#paint2_linear_318_3208)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4439 37.9959C13.7027 32.8845 20.5406 17.5672 34.3355 16.4445C34.3355 9.21535 40.1954 3.35547 47.4246 3.35547H39.2854C21.3911 3.34697 8.13196 22.3724 3.48828 37.9959H12.4439Z",
    fill: "url(#paint3_radial_318_3208)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4439 38C13.7027 43.1114 20.5406 58.4288 34.3355 59.5599C34.3355 66.7891 40.1954 72.649 47.4246 72.649H39.2854C21.3911 72.649 8.13196 53.6235 3.48828 38H12.4439Z",
    fill: "url(#paint4_linear_318_3208)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30475 37.9966C8.95693 22.3731 22.2076 3.34766 40.1104 3.34766H39.2939C21.3911 3.34766 8.13196 22.3731 3.48828 37.9966H4.30475Z",
    fill: "url(#paint5_linear_318_3208)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30475 38C8.94843 53.6235 22.2076 72.649 40.1019 72.649H39.2854C21.3911 72.649 8.13196 53.6235 3.48828 38H4.30475Z",
    fill: "url(#paint6_radial_318_3208)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.951 37.9959C286.692 32.8845 279.854 17.5672 266.068 16.4445C266.068 9.21534 260.208 3.35547 252.979 3.35547H261.118C279.012 3.35547 292.271 22.3809 296.915 38.0044H287.959L287.951 37.9959Z",
    fill: "url(#paint7_radial_318_3208)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.951 38C286.692 43.1114 279.854 58.4288 266.068 59.5599C266.068 66.7891 260.208 72.649 252.979 72.649H261.118C279.012 72.649 292.271 53.6235 296.915 38H287.959H287.951Z",
    fill: "url(#paint8_linear_318_3208)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.09 37.9966C291.446 22.3731 278.187 3.34766 260.293 3.34766H261.109C279.004 3.34766 292.263 22.3731 296.907 37.9966H296.09Z",
    fill: "url(#paint9_linear_318_3208)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.09 38C291.446 53.6235 278.187 72.649 260.293 72.649H261.109C279.004 72.649 292.263 53.6235 296.907 38H296.09Z",
    fill: "url(#paint10_radial_318_3208)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.88 59.3644C279.675 58.2418 286.513 42.916 287.764 37.8045C286.505 32.6931 279.667 17.3757 265.88 16.2531C265.88 9.02394 260.021 3.16406 252.791 3.16406H47.2365C40.0073 3.16406 34.1475 9.02394 34.1475 16.2531C20.3525 17.3757 13.5146 32.7016 12.2559 37.8045C13.5146 42.916 20.3525 58.2333 34.1475 59.3644C34.1475 66.5936 40.0073 72.4535 47.2365 72.4535H252.783C260.012 72.4535 265.872 66.5936 265.872 59.3644H265.88ZM286.037 37.8045C285.612 36.2311 284.931 34.6067 284.242 33.1608C283.137 30.839 281.785 28.5937 280.203 26.561C276.58 21.9089 271.774 18.4133 265.744 17.9201L264.205 17.7925V16.2446C264.205 9.94247 259.094 4.83102 252.791 4.83102H47.2365C40.9344 4.83102 35.8229 9.94247 35.8229 16.2446V17.7925L34.2835 17.9201C28.2536 18.4133 23.4483 21.9089 19.8252 26.561C18.2433 28.5937 16.891 30.839 15.7854 33.1608C15.0965 34.6067 14.4246 36.2396 13.9909 37.8045C14.4161 39.3779 15.0965 41.0024 15.7854 42.4482C16.891 44.77 18.2433 47.0153 19.8252 49.048C23.4483 53.7002 28.2536 57.1957 34.2835 57.689L35.8229 57.8165V59.3644C35.8229 65.6666 40.9344 70.778 47.2365 70.778H252.783C259.085 70.778 264.196 65.6666 264.196 59.3644V57.8165L265.736 57.689C271.766 57.1957 276.571 53.7002 280.194 49.048C281.776 47.0153 283.128 44.77 284.234 42.4482C284.923 41.0024 285.603 39.3694 286.029 37.8045H286.037Z",
    fill: "url(#paint11_linear_318_3208)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1784 37.9974C14.6036 36.424 15.284 34.7996 15.9729 33.3537C17.0785 31.0319 18.4308 28.7866 20.0127 26.7539C23.6358 22.1018 28.4411 18.6062 34.471 18.113L36.0104 17.9854L34.335 16.4375C20.54 17.5601 13.7021 32.886 12.4434 37.9889H14.1784V37.9974Z",
    fill: "url(#paint12_linear_318_3208)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9729 42.6437C15.284 41.1978 14.6121 39.5649 14.1784 38H12.4434C13.7021 43.1114 20.54 58.4288 34.335 59.5599L36.0104 58.012L34.471 57.8844C28.4411 57.3912 23.6358 53.8957 20.0127 49.2435C18.4308 47.2108 17.0785 44.9655 15.9729 42.6437Z",
    fill: "url(#paint13_linear_318_3208)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.6 37.9974C286.174 36.424 285.494 34.7996 284.805 33.3537C283.699 31.0319 282.347 28.7866 280.765 26.7539C277.142 22.1018 272.337 18.6062 266.307 18.113L264.768 17.9854L266.443 16.4375C280.238 17.5601 287.076 32.886 288.326 37.9889H286.591L286.6 37.9974Z",
    fill: "url(#paint14_linear_318_3208)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.431 42.6437C285.12 41.1978 285.801 39.5649 286.226 38H287.961C286.702 43.1114 279.864 58.4288 266.078 59.5599L264.402 58.012L265.942 57.8844C271.972 57.3912 276.777 53.8957 280.4 49.2435C281.982 47.2108 283.334 44.9655 284.44 42.6437H284.431Z",
    fill: "url(#paint15_linear_318_3208)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7731 16.6789C35.7731 10.3768 40.8846 5.26531 47.1867 5.26531H252.733C259.035 5.26531 264.147 10.3768 264.147 16.6789V18.2268L265.822 16.6789C265.822 9.44972 259.962 3.58984 252.733 3.58984H47.1867C39.9575 3.58984 34.0977 9.44972 34.0977 16.6789L35.7731 18.2268V16.6789Z",
    fill: "url(#paint16_linear_318_3208)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.423 70.9732C41.1209 70.9732 36.0095 65.8617 36.0095 59.5596V58.0117L34.334 59.5596C34.334 66.7888 40.1939 72.6486 47.423 72.6486H252.969C260.199 72.6486 266.058 66.7888 266.058 59.5596L264.383 58.0117V59.5596C264.383 65.8617 259.272 70.9732 252.969 70.9732H47.423Z",
    fill: "url(#paint17_linear_318_3208)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.196 2.16797C189.607 2.16797 225.43 2.61873 252.05 3.35015H48.3496C74.9699 2.61873 110.793 2.16797 150.204 2.16797H150.196Z",
    fill: "url(#paint18_linear_318_3208)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.196 71.5273C185.458 71.5273 217.513 71.9271 241.326 72.5819H59.0664C82.8801 71.9271 114.935 71.5273 150.196 71.5273Z",
    fill: "#C1E5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5134 14.7624C26.2538 15.6894 22.7753 17.4925 19.3223 21.6854C21.2018 16.4039 25.4033 13.6313 30.4637 12.8658C31.4503 9.41283 33.3383 7.55026 36.6978 6.45312C34.3334 8.50281 33.2278 10.3654 32.5134 14.7624Z",
    fill: "url(#paint19_linear_318_3208)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.888 14.7624C274.147 15.6894 277.626 17.4925 281.079 21.6854C279.199 16.4039 274.998 13.6313 269.937 12.8658C268.951 9.41283 267.063 7.55026 263.703 6.45312C266.067 8.50281 267.173 10.3654 267.888 14.7624Z",
    fill: "url(#paint20_linear_318_3208)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5134 61.2355C26.2538 60.3085 22.7753 58.5054 19.3223 54.3125C21.2018 59.594 25.4033 62.3666 30.4637 63.1321C31.4503 66.5851 33.3383 68.4476 36.6978 69.5448C34.3334 67.4951 33.2278 65.6325 32.5134 61.2355Z",
    fill: "url(#paint21_linear_318_3208)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.888 61.2355C274.147 60.3085 277.626 58.5054 281.079 54.3125C279.199 59.594 274.998 62.3666 269.937 63.1321C268.951 66.5851 267.063 68.4476 263.703 69.5448C266.067 67.4951 267.173 65.6325 267.888 61.2355Z",
    fill: "url(#paint22_linear_318_3208)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_3208",
    x1: 150.197,
    y1: 75.9998,
    x2: 150.197,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA1CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_318_3208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.197 18.9999) scale(107.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7987AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_3208",
    x1: 150.197,
    y1: 75.9999,
    x2: 150.197,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#887BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_318_3208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4564 20.6714) scale(19.7824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#788FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#536376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#36404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1E242B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_3208",
    x1: 3.48828,
    y1: 55.3245,
    x2: 47.4246,
    y2: 55.3245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_3208",
    x1: 21.7993,
    y1: 37.9966,
    x2: 21.7993,
    y2: 3.34766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_318_3208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7993 55.3245) scale(17.8263 17.8263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7987AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_318_3208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(274.938 0.421279) scale(19.7824 19.7824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#788FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#536376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#36404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1E242B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_3208",
    x1: 274.938,
    y1: 38,
    x2: 274.938,
    y2: 72.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_3208",
    x1: 278.604,
    y1: -0.00327399,
    x2: 278.604,
    y2: -0.00327399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_318_3208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.604 55.3245) scale(17.8263 17.8263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7987AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_3208",
    x1: 12.2559,
    y1: 37.813,
    x2: 287.764,
    y2: 37.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_3208",
    x1: 24.2311,
    y1: 37.9974,
    x2: 24.2311,
    y2: 16.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7671B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_3208",
    x1: 24.2311,
    y1: 59.5599,
    x2: 24.2311,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99ABD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_3208",
    x1: 276.547,
    y1: 16.446,
    x2: 276.547,
    y2: 37.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7671B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_3208",
    x1: 276.173,
    y1: 0.000118379,
    x2: 276.173,
    y2: 0.000118379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99ABD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_3208",
    x1: 149.968,
    y1: 18.2268,
    x2: 149.968,
    y2: 3.58984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_3208",
    x1: 150.196,
    y1: 72.6486,
    x2: 150.196,
    y2: 58.0117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_318_3208",
    x1: 150.196,
    y1: 3.35015,
    x2: 150.196,
    y2: 2.16797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C66A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_318_3208",
    x1: 19.3223,
    y1: 14.0735,
    x2: 36.6978,
    y2: 14.0735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_318_3208",
    x1: 263.703,
    y1: 14.0735,
    x2: 281.079,
    y2: 14.0735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_318_3208",
    x1: 19.3223,
    y1: 61.9244,
    x2: 36.6978,
    y2: 61.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_318_3208",
    x1: 263.703,
    y1: 61.9244,
    x2: 281.079,
    y2: 61.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBorder);
export default __webpack_public_path__ + "static/media/button-border.39a07726610b59233687431eac6e82b6.svg";
export { ForwardRef as ReactComponent };